import { useEffect, useState } from 'react';
import { getClients } from 'services/clients';
import { Client } from 'types/clients';

export const useClientOptions = () => {
  const [clientOptions, setClientOptions] = useState<{ value: string; label: string }[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchClients = async () => {
      setLoading(true);
      const data = await getClients({});
      const client = data.clients as Client[];
      setClientOptions(
        client
          .map((item) => ({
            value: String(item.id),
            label: item.clientName
          }))
          .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }))
      );
      setLoading(false);
    };
    fetchClients();
  }, []);

  return { clientOptions, loading };
};
